import { Component, OnInit, OnDestroy } from '@angular/core';
import { ImageUploadService } from '@app/services/image-upload/image-upload.service';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-report-logo',
  templateUrl: './report-logo.component.html',
  styleUrls: ['./report-logo.component.scss']
})
export class ReportLogoComponent implements OnInit {
  public imageUpload$;
  public isLoading: boolean = true;
  public subs: SubSink = new SubSink;
  constructor(
    public _imageUpload: ImageUploadService
  ) { }

  ngOnInit(): void {
    this._imageUpload.onGetReportLogo();
    this.subs.add(this._imageUpload.imageReportLogo$.subscribe(res => {
      this.imageUpload$ = res;
    }));
  }

  ngOnDestroy(){
    this.subs.unsubscribe();
  }
}
